package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.InventoryItem
import fr.manyverse.app.domain.model.InventoryItemToCreate
import fr.manyverse.app.domain.repository.InventoryRepository
import fr.manyverse.app.domain.validation.InventoryItemValidator

class CreateInventoryItemUseCase(
    private val inventoryRepository: InventoryRepository
) {
    suspend operator fun invoke(item: InventoryItemToCreate): Result<InventoryItem> {
        InventoryItemValidator.validateForCreation(item.name, item.quantity).onFailure {
            return Result.failure(it)
        }

        return inventoryRepository.createItem(item)
    }
}
